import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { getViolationNameMapping } from '@components/WhatsappChallanNewFlow/helper'
import { parsePromiseResponse } from '@utils/promiseResponse'
import { formatDateDdMmYyyy } from '@utils/dateFormatChallan'

interface ChallanData {
    title: string
    date: string
    amount: string
    location: string
}

const fetchChallanFromApi = async (url: string) => {
    const response = await fetch(url)
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
    }
    return await response.json()
}

const mapChallanResponse = (
    challanResponse: any,
    violationNameMapping: Record<string, string> = {}
): ChallanData[] => {
    if (!Array.isArray(challanResponse?.data)) {
        return []
    }

    return challanResponse.data.map((item: any) => {
        const offence = item?.violations?.details?.[0]?.offence || ''
        return {
            title: violationNameMapping[offence] || offence,
            date: formatDateDdMmYyyy(item?.violations?.date),
            amount: item?.amount?.total,
            location: item?.violations?.location,
        }
    })
}

export const handleNonVahanStateChallan = async (regNo: string, _envConfig?: string) => {
    const [challanResult, violationResult] = (await Promise.allSettled([
        fetchChallanFromApi(API_URL_FACTORY.VIEW_CHALLAN_ENDPOINT(regNo)),
        getViolationNameMapping(),
    ])) as [PromiseSettledResult<any>, PromiseSettledResult<any>]

    const violationNameMapping = parsePromiseResponse(violationResult) || {}
    if (challanResult.status === 'fulfilled') {
        return mapChallanResponse(challanResult.value, violationNameMapping)
    }
    return null
}

export const handleMaharashtraChallan = async (regNo: string, _envConfig?: string) => {
    const [challanResult, violationResult] = (await Promise.allSettled([
        fetchChallanFromApi(API_URL_FACTORY.VIEW_MAHARASHTRA_CHALLAN_ENDPOINT(regNo)),
        getViolationNameMapping(),
    ])) as [PromiseSettledResult<any>, PromiseSettledResult<any>]

    const violationNameMapping = parsePromiseResponse(violationResult) || {}
    if (challanResult.status === 'fulfilled') {
        return mapChallanResponse(challanResult.value, violationNameMapping)
    }
    return null
}

export const handleVahanStateChallan = async (regNo: string, _envConfig?: string) => {
    const [challanResult, violationResult] = (await Promise.allSettled([
        fetchChallanFromApi(API_URL_FACTORY.VIEW_ULIP_ENDPOINT_WRAPPER(regNo)),
        getViolationNameMapping(),
    ])) as [PromiseSettledResult<any>, PromiseSettledResult<any>]

    const violationNameMapping = parsePromiseResponse(violationResult) || {}
    if (challanResult.status === 'fulfilled') {
        return mapChallanResponse(challanResult.value, violationNameMapping)
    }
    return null
}
